var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fruits-veg",on:{"click":_vm.typeClick}},[_c('div',[_c('img',{attrs:{"src":require('../../assets/' + _vm.fv.imgName + '.jpg'),"alt":""}}),_c('h4',{staticClass:"name"},[_vm._v(_vm._s(_vm.fv.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }